import SongItems from "./SongItems";

const SongList = ({ songs, playSong }) => {
  return (
    <div className="grid grid-flow-rows md:grid-cols-3  sm:grid-cols-2 grid-cols-1 gap-4 ">
      {songs &&
        songs.map((song) => {
          return <SongItems key={song.id} {...song} playSong={playSong} />;
        })}
    </div>
  );
};

export default SongList;
